export default "__VITE_PUBLIC_ASSET__73f4024d__"